import request from '@/utils/request'

// 进入所有技能认证大页面
// 获取所有技能认证状态
export function getSkillStatus() {
    return request({
      url: '/system/skillAuthentication/getStates/',
      method: 'get',
    })
}

// 进入某个技能认证详细页面
// 1、字典获取工作类型/行业领域数据
export function getType(type) {
  return request({
    url: '/data/type/' + type,
    method: 'get'
  })
}
// 2、获取用户技能认证资料
export function getSkillAc(type) {
  return request({
    // url: '/system/skillAuthentication/' + userId + '/' + type,
    url: '/system/skillAuthentication/' + type,
    method: 'get',
  })
}

// 3、提交用户技能认证资料
export function postSkillAc(data) {
  return request({
    url: '/system/skillAuthentication',
    method: 'post',
    data: data,
  })
}

// 4、审核不通过，重新提交
export function againPostSkillAc(data) {
  return request({
    url: '/system/skillAuthentication',
    method: 'put',
    data: data,
  })
}

// 5、证书
export function getCertificate(type) {
    return request({
      url: '/certificates/' + type,
      method: 'get',
    })
  }
// 7、建模 申请认证
export function examineAdd(data) {
  return request({
    url: '/examine/add',
    method: 'post',
    data: data,
  })
}
// 8、建模 申请认证
export function examineModel() {
  return request({
    url: '/examine/examineStatus',
    method: 'get',
  })
}
// 9、建模 查看证书
export function certificatesModel() {
  return request({
    url: '/certificates/modeling/',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/accept/ca/skills.js